import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContenedoresService } from './../../../../../../../../services/API/contenedores/contenedores.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { NotificationServiceService } from './../../../../../../../../services/notification-service/notification-service.service';

@Component({
    selector: 'app-edit-mantenimiento',
    templateUrl: './edit-mantenimiento.component.html',
    styleUrls: ['./edit-mantenimiento.component.css'],
    standalone: false
})
export class EditMantenimientoComponent implements OnInit {

  showProgressBar: boolean = true;
  contenedores: any = [];
  contenedoresSearch: any = [];
  form: UntypedFormGroup;
  contenedor: any = -1;
  mantenimiento: number = -1;
  tipo: string;

  fechaAlta: any = "";
  fechaAltaFinal: any = "";
  fechaAccion: any = "";
  fechaAccionFinal: any = "";

  coste: string = '0';
  observaciones: string = '';
  estado: string = 'pending';

  constructor(private fb: UntypedFormBuilder, private contenedoresService: ContenedoresService, private notificationService: NotificationServiceService, 
              @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<EditMantenimientoComponent>) { }

  ngOnInit(): void {
    if(this.data['contenedor'] === 'all'){
      this.contenedor = -1;
    }else{
      this.contenedor = this.data['contenedor'];
    }
    this.mantenimiento = parseInt(this.data['mantenimiento']);
    this.tipo = this.data['tipo'];
    this.coste = this.data['coste'];
    this.observaciones = this.data['observaciones'];
    this.estado = this.data['estado'];

    var date = (this.data['fechaAlta'].replace("-", "/")).replace("-", "/");
    date = date.split(/\//);
    date = [ date[1], date[0], date[2] ].join('/');
    this.fechaAlta = new Date(date);
    this.fechaAltaFinal = this.data['fechaAlta'];

    var date2 = (this.data['fechaAccion'].replace("-", "/")).replace("-", "/");
    date2 = date2.split(/\//);
    date2 = [ date2[1], date2[0], date2[2] ].join('/');
    this.fechaAccion = new Date(date2);
    this.fechaAccionFinal = this.data['fechaAccion'];

    this.getContenedores();
    this.form = this.fb.group({
      contenedor: [this.contenedor, [Validators.required, Validators.minLength(1)]],
      tipo: [this.tipo, [Validators.required, Validators.minLength(1)]],
      coste: [this.coste, [Validators.required, Validators.pattern("^[0-9]+(\\.[0-9]{1,2})?$")]],
      observaciones: [this.observaciones, [Validators.maxLength(128)]],
      estado: [this.estado, [Validators.required, Validators.minLength(1)]],
      fechaAlta: [this.fechaAlta, [Validators.required]],
      fechaAccion: [this.fechaAccion, [Validators.required]],  
    });
  }

  getContenedores() {
    this.showProgressBar = true;
    this.contenedoresService.getContenedores('all').subscribe(result => {
      this.showProgressBar = false;
      this.contenedores = result;
      this.contenedoresSearch = this.contenedores;
    });
  }

  filterSelect_Contenedores(value: string) { 
    this.contenedoresSearch =this.contenedores.filter(option => option['matricula'].toLowerCase().includes(value.toLowerCase()));
  }

  save() {
    const {value, valid } = this.form;
    if(valid && this.mantenimiento > 0){
      this.showProgressBar = true;
      this.contenedoresService.updateMantenimiento(this.mantenimiento, value.contenedor.toString(), value.tipo, this.fechaAltaFinal, this.fechaAccionFinal, value.coste, value.observaciones, value.estado).subscribe(() => {
        this.notificationService.openSnackBar("Mantenimiento modificado correctamente!");
        this.showProgressBar = false;
        this.close('save');
      });
    }else{
      this.notificationService.openSnackBar("❌ ERROR: Datos incorrectos.");
    }
  }

  close(data: string = '') {
    this.dialogRef.close(data);
  }

  dateChangeAlta(event: any){
    let fecha: any;
    if(event instanceof Date) {
      fecha = event;
    }else {
      fecha = new Date(event.target.value);
    }
    fecha = fecha.getDate()+"-"+(fecha.getMonth()+1)+"-"+fecha.getFullYear();
    this.fechaAltaFinal = fecha;
  }

  dateChangeAccion(event: any){
    let fecha: any;
    if(event instanceof Date) {
      fecha = event;
    }else {
      fecha = new Date(event.target.value);
    }
    fecha = fecha.getDate()+"-"+(fecha.getMonth()+1)+"-"+fecha.getFullYear();
    this.fechaAccionFinal = fecha;
  }

}
